import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ApplicationForm } from '@/components/forms/ApplicationForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateApplicationPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/system-settings/applications')
  }

  const handleCancel = () => {
    navigate('/system-settings/applications')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Application</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new web or mobile application
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex={1} minH={0}>
            <ApplicationForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
